import React from "react";
import { Card, CardContent } from "./ui/card";
import { Zap, Target, Heart, Award, Users, CheckCircle, Calendar, Code } from "lucide-react";
import { mockData } from "../mock/mockData";

const AboutSection = () => {
  const { company, stats } = mockData;

  const getStatIcon = (iconName) => {
    const icons = {
      users: <Users className="w-8 h-8" />,
      checkcircle: <CheckCircle className="w-8 h-8" />,
      calendar: <Calendar className="w-8 h-8" />,
      code: <Code className="w-8 h-8" />
    };
    return icons[iconName] || <Award className="w-8 h-8" />;
  };

  return (
    <section id="nosotros" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#252F4A] mb-6">
            Sobre <span className="text-[#3E97FF]">Nosotros</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#3E97FF] to-[#27AE60] mx-auto mb-6"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          {/* Content */}
          <div className="space-y-6">
            <p className="text-lg text-[#252F4A]/80 leading-relaxed">
              {company.description}
            </p>
            
            <div className="space-y-4">
              <h3 className="text-2xl font-semibold text-[#252F4A] mb-4">Nuestra Misión</h3>
              <p className="text-[#252F4A]/70 leading-relaxed">
                {company.mission}
              </p>
            </div>

            <div className="space-y-4">
              <h3 className="text-2xl font-semibold text-[#252F4A] mb-4">Nuestra Visión</h3>
              <p className="text-[#252F4A]/70 leading-relaxed">
                {company.vision}
              </p>
            </div>

            {/* Values */}
            <div className="grid grid-cols-2 gap-4 mt-8">
              {company.values.map((value, index) => {
                const icons = [
                  <Zap className="w-5 h-5" />,
                  <Target className="w-5 h-5" />,
                  <Heart className="w-5 h-5" />,
                  <Award className="w-5 h-5" />
                ];
                const colors = ["text-[#3E97FF]", "text-[#27AE60]", "text-[#FF6B35]", "text-[#1C3C73]"];
                
                return (
                  <div key={index} className="flex items-center space-x-3">
                    <div className={colors[index]}>
                      {icons[index]}
                    </div>
                    <span className="text-[#252F4A]/80 font-medium text-sm">{value}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Image placeholder */}
          <div className="relative">
            <div className="aspect-square rounded-2xl flex items-center justify-center relative overflow-hidden shadow-lg">              
              <img
                src="/images/about-us-team.jpg"
                alt="Equipo de Infinitux Solutions trabajando colaborativamente en oficina moderna, simbolizando tecnología avanzada y gestión experta."
                className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500 ease-in-out"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-[#3E97FF]/10 to-[#1C3C73]/20 opacity-30"></div>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <Card key={index} className="text-center p-6 hover:shadow-lg transition-shadow border-0 bg-gradient-to-br from-[#F6F6F6] to-white">
              <CardContent className="p-0">
                <div className="text-[#3E97FF] mb-4 flex justify-center">
                  {getStatIcon(stat.icon)}
                </div>
                <div className="text-3xl font-bold text-[#252F4A] mb-2">{stat.value}</div>
                <div className="text-[#252F4A]/70 text-sm font-medium">{stat.label}</div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;